import { v4 } from "uuid"
import {
    ApplicationTemplate,
    ApplicationTemplateCategory,
    ApplicationTemplateVersion
} from "../../../models/workshop/template"
import { ApplicationType, TemplateId, TemplateVersionStatus } from "../../../models/workshop/common"
import { ApplicationInstance } from "../../../models/workshop/instance"

export const getEmptyApplicationTemplate = (): ApplicationTemplate => ({
    Id: `temp_${v4()}`,
    Title: "Новое приложение",
    ApplicationType: ApplicationType.AGENT,
    Description: "",
    AutoPublished: true,
    Audit: {
        CreateTimestamp: new Date().getTime(),
        UpdateTimestamp: new Date().getTime(),
        CreateBy: "test",
        UpdateBy: "test"
    }
})

export const getEmptyApplicationTemplateVersion = (templateId: TemplateId): ApplicationTemplateVersion => ({
    Id: `temp_${v4()}`,
    TemplateId: templateId,
    Version: {
        Main: 1,
        Sub: 0
    },
    Title: "Новая версия приложения",
    Settings: {
        Tabs: [],
        Groups: [],
        Fields: []
    },
    EntitiesTemplates: [],
    Meta: {},
    Status: TemplateVersionStatus.DRAFT,
    Descriptions: {
        Usage: "",
        ChangeLog: ""
    },
    Audit: {
        CreateBy: "test",
        UpdateBy: "test",
        CreateTimestamp: new Date().getTime(),
        UpdateTimestamp: new Date().getTime()
    }
})

export const getMockedCatalog = (): ApplicationTemplateCategory[] => {
    const template = getEmptyApplicationTemplate()
    const templateVersion = getEmptyApplicationTemplateVersion(template.Id)

    return [
        {
            Id: template.Id,
            Title: template.Title,
            Audit: templateVersion.Audit,
            Versions: [
                {
                    Id: templateVersion.Id,
                    Title: templateVersion.Title,
                    Status: templateVersion.Status,
                    Audit: templateVersion.Audit
                }
            ]
        }
    ]
}

export const getMockedApplicationInstance = (title?: string, channelId?: string): ApplicationInstance => ({
    Id: v4(),
    Title: title ?? "Default title",
    TemplateId: v4(),
    ApplicationType: ApplicationType.CHANNEL,
    Descriptions: { Title: "Default", Usage: "Default", ChangeLog: "Default" },
    Entities: [{ EntityType: ApplicationType.CHANNEL, Id: channelId ?? "Default channel id" }],
    Settings: { Tabs: [], Groups: [], Fields: [] },
    VersionId: v4(),
    Version: { Main: 1, Sub: 0 },
    Audit: { CreateTimestamp: 0, CreateBy: "test", UpdateTimestamp: 0, UpdateBy: "test" }
})
